import React from 'react'
import { fontSize, spacer } from 'stylist'
import { CenteredCol } from 'components/Col'
import { Bold } from 'components/Text'
import styled from '@emotion/styled'
import { commaify } from 'utils'

const Price = styled(Bold)`
  ${fontSize('xxl')};
`

const TotalPrice = styled.div`
  margin-top: ${spacer(4)};
`

const ResultPrice = ({ price, totalPrice }) => (
  <React.Fragment>
    <CenteredCol>
      <Price>${commaify(price)}</Price>/Complete
    </CenteredCol>
    <TotalPrice>Total: ${commaify(totalPrice)}</TotalPrice>
  </React.Fragment>
)

export default ResultPrice



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/results/ResultPrice.js